export const OPEN_FILTER_QUERY = 'mjk';
export const CATEGORIES_QUERY_PARAM = 'categories';
export const SUB_TYPES_QUERY_PARAM = 'subTypes';
export const CLASSIFICATIONS_QUERY_PARAM = 'classifications';
export const FLAVORS_QUERY_PARAM = 'flavors';
export const EFFECTS_QUERY_PARAM = 'effects';
export const GENERALS_QUERY_PARAM = 'generals';
export const BRANDS_QUERY_PARAM = 'brands';
export const TYPE_SUBTYPES_QUERY_PARAM = 'typeSubtypes';
export const MIN_THC_QUERY_PARAM = 'minThc';
export const MAX_PRICE_QUERY_PARAM = 'maxPrice';
export const ACTIVE_FILTER_QUERY_PARAMS = [
  CLASSIFICATIONS_QUERY_PARAM,
  FLAVORS_QUERY_PARAM,
  EFFECTS_QUERY_PARAM,
  GENERALS_QUERY_PARAM,
  BRANDS_QUERY_PARAM,
];

export const advancedFilterQueryParams = [
  OPEN_FILTER_QUERY,
  CATEGORIES_QUERY_PARAM,
  SUB_TYPES_QUERY_PARAM,
  CLASSIFICATIONS_QUERY_PARAM,
  FLAVORS_QUERY_PARAM,
  EFFECTS_QUERY_PARAM,
  GENERALS_QUERY_PARAM,
  BRANDS_QUERY_PARAM,
  TYPE_SUBTYPES_QUERY_PARAM,
  MIN_THC_QUERY_PARAM,
  MAX_PRICE_QUERY_PARAM,
];

export const getAllAdvancedFilterQueryParameters = () => advancedFilterQueryParams.concat(ACTIVE_FILTER_QUERY_PARAMS);



// WEBPACK FOOTER //
// ./src/components/AdvancedFilter/filter_constants.js